import React, { useState } from "react";

const DroppingPointArrayComponent = (props) => {
    const [showdroppingPoint, setshowdroppingPoint] = useState(props.selectedDroppingPoint)

    const addPointHandler = (x) => {

        props.addDroppingPoint(x);
        setshowdroppingPoint(x)

    };
    return (
        <div className="flex flex-col   h-[20rem]  overflow-y-scroll ">
            {props.stops.map((x) => (
                <div
                    onClick={() => addPointHandler(x)}
                    className={x === showdroppingPoint ? "flex gap-7 bg-blue-100 items-center cursor-pointer  pl-4 pr-4 py-6 " : "flex gap-7 items-center cursor-pointer  pl-4 pr-4 py-6 "}
                >
                    <p className="text-xl font-semibold">{x.time}</p>
                    <div>
                        <p className="text-xl font-semibold">{x.pointname}</p>
                        <p className="text-lg text-gray-500">{x.pointAddress}</p>
                    </div>
                </div>
            ))
            }
        </div >
    );
};

export default DroppingPointArrayComponent;

